// MACHINERY V2 (Stroje) — the canonical Radix portal wrapper (M2.1; split out
// of ChromeRightMenus.tsx at M2.2 for the 300-line cap).
//
// >>> THIS IS THE CANONICAL IMPLEMENTATION OF THE PORTAL RULE. <<<
// CapTip.tsx and ReadinessPopupV2.tsx carry hand-copied versions because they
// are bound to Tooltip.Content / Dialog.Content, which cannot be rendered
// inside a DropdownMenu.Root. If the countermeasure changes, change all three.
//
// The rule (MachineryV2Layout.tsx's header), for real and not in theory:
//   - Radix renders *.Content into document.body, OUTSIDE .machinery-v2-root,
//     where --card / --border / --ink / --shadow / --mod-accent do NOT resolve.
//     Content therefore RE-CARRIES `machinery-v2-root p-<palette> mod-stroje`.
//   - Re-carrying the root class also re-applies its opaque `background:
//     var(--bg)`, so Content sets inline background:"transparent" and lets the
//     inner `.ms-menu` div paint the surface. Without it, Content would paint a
//     page-coloured slab.
//   - `palette` is read from machineryV2UiSlice INSIDE this component, live on
//     EVERY render — never captured at mount, or a menu opened before a palette
//     flip would keep the old palette while the page changed.
//
// No Tailwind, no shadcn, no MUI, no @emotion, no sx, no dt tokens.
import React from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";

import { useAppSelector } from "../../../../shared/hooks/sharedHooks";

export const MenuContent: React.FC<{ width: number; children: React.ReactNode }> = ({
  width,
  children,
}) => {
  const palette = useAppSelector((s) => s.machineryV2Ui.palette);
  return (
    <DropdownMenu.Portal>
      <DropdownMenu.Content
        className={`machinery-v2-root p-${palette} mod-stroje`}
        align="end"
        sideOffset={8}
        style={{ background: "transparent", zIndex: 1290 }}
      >
        {/* role="none": Radix puts role="menu" on Content and role="menuitem"
            on each Item; this presentational box sits between them, so it must
            not break the ARIA parent-child relationship. */}
        <div className="ms-menu" role="none" style={{ width }}>
          {children}
        </div>
      </DropdownMenu.Content>
    </DropdownMenu.Portal>
  );
};

export default MenuContent;
